import { defineComponent as m, computed as p, createBlock as c, openBlock as r, withCtx as d, createElementBlock as u, createCommentVNode as g, toDisplayString as b } from "vue";
import f from "./SidebarListElementForm.vue.js";
const v = {
  key: 0,
  class: "text-c-2 text-sm leading-normal text-pretty"
}, w = /* @__PURE__ */ m({
  __name: "DeleteSidebarListElement",
  props: {
    variableName: {},
    warningMessage: {}
  },
  emits: ["close", "delete"],
  setup(l, { emit: o }) {
    const t = l, a = o, s = p(() => t.variableName.length > 18 ? t.variableName.slice(0, 18) + "…" : t.variableName);
    return (n, e) => (r(), c(f, {
      danger: "",
      label: `Delete ${s.value}`,
      onCancel: e[0] || (e[0] = (i) => a("close")),
      onSubmit: e[1] || (e[1] = (i) => a("delete"))
    }, {
      default: d(() => [
        n.warningMessage ? (r(), u("p", v, b(n.warningMessage), 1)) : g("", !0)
      ]),
      _: 1
    }, 8, ["label"]));
  }
});
export {
  w as default
};
